import { Link } from "react-router-dom";

export default function AboutProgram() {
  return (
    <div className="max-w-[1100px] mx-auto px-6 lg:px-12 py-20" data-testid="page-about">
      <div className="text-[11px] uppercase tracking-[0.3em] kazo-text-burgundy mb-4">ABOUT THE PROGRAMME</div>
      <h1 className="editorial-headline text-5xl lg:text-7xl mb-8">A members-only<br /><em className="font-light">universe.</em></h1>
      <div className="prose max-w-3xl text-neutral-700 leading-relaxed text-lg">
        <p>Orchid Petals is the official loyalty programme of The Orchid Hotels — Asia's first 5-star eco-luxury chain. We built it as a quiet thank-you to our guests: Petals that gather softly on every stay, privileges that arrive on the right occasion, and a private door into our most-anticipated openings and seasonal experiences.</p>
        <p className="mt-6">There are no annual fees. No fine print buried in legalese. Just a programme that rewards what you already love doing — travelling well, dining beautifully, and resting deeply.</p>
      </div>
      <div className="grid md:grid-cols-3 gap-8 mt-16">
        {[
          { h: "Free to join", b: "No fee, no waitlist. Enrol in 30 seconds at the front desk of any Orchid property or online." },
          { h: "Universally accepted", b: "Earn and redeem Petals across all 25+ Orchid eco-luxury properties in India and on orchidhotel.com." },
          { h: "Designed for travellers", b: "Tailored privileges — suite upgrades, late check-outs, spa indulgences and curated experiences." },
        ].map((c) => (
          <div key={c.h} className="border border-black/10 p-8 bg-white">
            <h3 className="font-display text-2xl mb-2">{c.h}</h3>
            <p className="text-sm text-neutral-600 leading-relaxed">{c.b}</p>
          </div>
        ))}
      </div>
      <Link to="/" className="mt-12 inline-block k-btn kazo-bg-burgundy text-white uppercase tracking-widest text-xs" data-testid="about-join-now-btn">Join now</Link>
    </div>
  );
}
